import { type AssignV3ActionMode } from "@redotech/redo-flows-common/rules/actions";
import { AssignmentTypeOption } from "@redotech/redo-flows-common/rules/schemas";

export function serializeCurrentAssignmentTypes(
  assignmentTypes: readonly AssignmentTypeOption[],
): AssignmentTypeOption[] | undefined {
  return assignmentTypes.length > 0 ? [...assignmentTypes] : undefined;
}

export function defaultCurrentAssignmentTypesForMode(
  mode: AssignV3ActionMode["_tag"],
): AssignmentTypeOption[] {
  return [
    mode === "unassign"
      ? AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE
      : AssignmentTypeOption.NO_ASSIGNEE,
  ];
}
